import moment from "moment";
import { capitalizeEachWord, capitalizeFirstLetter } from "utils/helpers";

export const selfAssessmentResultTemplate = (
  values,
  assessmentQuestionnaire,
  finalInitialRecommendation,
  totalScore,
  totalOptionA,
  totalOptionB,
  totalOptionC,
  totalOptionD
) => {
  let assessmentQuestionnaireTable = ``;

  const subjectFontSize = (program, subjectIndex) => {
    let fontSize = "18px";
    if (
      program === "BSB50820 Diploma of Project Management" &&
      subjectIndex === 1
    ) {
      fontSize = "14px";
    }
    return fontSize;
  };

  const descriptionFontSize = (program, subjectIndex) => {
    let fontSize = "16px";
    if (
      program === "BSB50820 Diploma of Project Management" &&
      subjectIndex === 1
    ) {
      fontSize = "12px";
    }
    return fontSize;
  };

  const headerSubjectDescWidth = (program, subjectIndex) => {
    let width = "40%";
    if (
      program === "BSB50820 Diploma of Project Management" &&
      subjectIndex === 1
    ) {
      width = "30%";
    }
    return width;
  };

  const rowContentPadding = (program, subjectIndex) => {
    let padding = "16px";
    if (
      program === "BSB50820 Diploma of Project Management" &&
      subjectIndex === 1
    ) {
      padding = "8px";
    }
    return padding;
  };

  if (
    assessmentQuestionnaire &&
    assessmentQuestionnaire.list &&
    assessmentQuestionnaire.list.length > 0
  ) {
    for (let m = 0; m < assessmentQuestionnaire.list.length; m++) {
      let assessmentQuestionnaireRow = ``;
      const subject = assessmentQuestionnaire.list[m].subject;
      let subjectRow = `
                <tr style="border:3px solid black;"><td colspan="5"style="padding: ${rowContentPadding(
                  values.selected_program,
                  m
                )}; font-size: ${subjectFontSize(
        values.selected_program,
        m
      )};font-weight: 700; text-transform: uppercase; background-color: #E5E7EB; border:3px solid black;">${subject}</td></tr>
            `;
      assessmentQuestionnaireRow += subjectRow;

      const descriptionList = assessmentQuestionnaire.list[m].description;
      if (descriptionList && descriptionList.length > 0) {
        for (let n = 0; n < descriptionList.length; n++) {
          const description = descriptionList[n];
          let descriptionRow = `
                        <tr style="border:3px solid black;"><td style="padding: ${rowContentPadding(
                          values.selected_program,
                          m
                        )}; font-size: ${descriptionFontSize(
            values.selected_program,
            m
          )};border:3px solid black; ">${description}</td><td style="padding: ${rowContentPadding(
            values.selected_program,
            m
          )};border:3px solid black; text-align: center;"><input ${
            values[`subject_${m}_description_${n}`] === "A" && 'checked="true"'
          } disabled="true" id=${`subject-${m}-description-${n}-radio-btn`} type="radio" name=${`subject_${m}_description_${n}`} style="width: 16px; height: 16px; " /></td><td style="padding: ${rowContentPadding(
            values.selected_program,
            m
          )};border:3px solid black; text-align: center;"><input ${
            values[`subject_${m}_description_${n}`] === "B" && 'checked="true"'
          } disabled="true" id=${`subject-${m}-description-${n}-radio-btn`} type="radio" name=${`subject_${m}_description_${n}`} style="width: 16px; height: 16px; " /></td><td style="padding: ${rowContentPadding(
            values.selected_program,
            m
          )};border:3px solid black; text-align: center;"><input ${
            values[`subject_${m}_description_${n}`] === "C" && 'checked="true"'
          } disabled="true" id=${`subject-${m}-description-${n}-radio-btn`} type="radio" name=${`subject_${m}_description_${n}`} style="width: 16px; height: 16px; " /></td><td style="padding: ${rowContentPadding(
            values.selected_program,
            m
          )};border:3px solid black; text-align: center;"><input ${
            values[`subject_${m}_description_${n}`] === "D" && 'checked="true"'
          } disabled="true" id=${`subject-${m}-description-${n}-radio-btn`} type="radio" name=${`subject_${m}_description_${n}`} style="width: 16px; height: 16px; " /></td></tr>
                    `;
          assessmentQuestionnaireRow += descriptionRow;
        }
      }
      let assessmentQuestionnaireContainerTable = `
                <!-- Interlink Logo -->
                <section style="max-width: 1024px; margin: auto"><div style="display: flex;justify-content: space-between;align-items: center;"><p style="font-size: 35px;font-weight: 700; text-transform: uppercase;">Evaluation Result</p><img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/3cc70924b3ab74185ad71fe90d402dc31b6ead35e23c071e629cb519d6998e5e3d1907418e962c9192d0b994cd463a1439568da53918e40c0038a012aa8420707317e593995d92f07547d822aa4772e5bf3d952cde8dfda477bc763adda0015308fc8b18729c0da63f913a6a6b2c81ace3475faea09cc214e76b/file-1723698395598.png" alt="Interlink-Logo" style="object-fit: contain; height: 90px;padding: 30px 0;" /></div></section>
                <!-- Questionnaire Form -->
                <section style="max-width: 1024px; margin: auto"><div style="margin-bottom: 1500px;padding: 20px 32px 36px 32px;border-radius: 10px; background-color: #F3F4F6; line-height: 18px;"><div style="margin-bottom: 20px; color: #0EA5E9;font-size: 22px;font-weight: 700; text-transform: uppercase; line-height: 32px;">${
                  assessmentQuestionnaire.name
                }</div><table style="width: 100%; border:3px solid black; border-collapse: collapse; table-layout: auto;"><tr style="border:3px solid black;"><th style="width: ${headerSubjectDescWidth(
        values.selected_program,
        m
      )}; padding: 16px; border:3px solid black; text-align: left; background-color: #D1D5DB;"><p style="font-size: 18px;font-weight: 700; text-transform: uppercase; ">Subject Area</p><p style="font-size: 16px; font-weight: 400; ">Description</p></th><th style="font-size: 12px; padding: 16px; border:3px solid black; text-align: center; background-color: #D1D5DB;">I have never done or participated in this or I do not know<br>(A)</th><th style="font-size: 12px; padding: 16px; border:3px solid black; text-align: center; background-color: #D1D5DB;">I have done, or do this, under super vision<br>(B)</th><th style="font-size: 12px; padding: 16px; border:3px solid black; text-align: center; background-color: #D1D5DB;">I sometimes do this, or have done this during the past 3 years<br>(C)</th><th style="font-size: 12px; padding: 16px; border:3px solid black; text-align: center; background-color: #D1D5DB;">I often do this, or have often done this within the past 3 years<br>(D)</th></tr>${assessmentQuestionnaireRow}${
        m + 1 === assessmentQuestionnaire.list.length
          ? `<tr style="border:3px solid black;"><td style="background-color: #38BDF8; text-align: left; "><p style="padding-left: 16px; font-size: 16px;font-weight: 700; color: #ffffff; text-transform: uppercase; ">Accumulated Points</p></td><td style="background-color: #38BDF8; border:3px solid black;"><p style="font-size: 16px;font-weight: 700; text-align: center; color: white; ">${totalOptionA}</p></td><td style="background-color: #38BDF8; border:3px solid black;"><p style="font-size: 16px;font-weight: 700; text-align: center; color: white; ">${totalOptionB}</p></td><td style="background-color: #38BDF8; border:3px solid black;"><p style="font-size: 16px;font-weight: 700; text-align: center; color: white; ">${totalOptionC}</p></td><td style="background-color: #38BDF8; border:3px solid black;"><p style="font-size: 16px;font-weight: 700; text-align: center; color: white; ">${totalOptionD}</p></td></tr>`
          : ""
      }</table></div></section>
            `;
      assessmentQuestionnaireTable += assessmentQuestionnaireContainerTable;
    }
  }

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head><meta charset="UTF-8" /><meta name="viewport" content="width=device-width, initial-scale=1.0" /><title>Evaluation Result</title><style media="screen">input[type="radio"]:disabled {-webkit-appearance: none;display: inline-block;width: 12px;height: 12px;padding: 0px;background-clip: content-box;border: 2px solid #bbbbbb;background-color: white;border-radius: 50%;} input[type="radio"]:checked {background-color: #6B7280;}</style></head>
    <body style="font-family: 'Poppins', sans-serif; font-size: 16px">
        <div style="background-color: white">
            <!-- Interlink Logo -->
            <section style="max-width: 1024px; margin: auto"><div style="display: flex;justify-content: space-between;align-items: center;"><p style="font-size: 35px;font-weight: 700; text-transform: uppercase;">Evaluation Result</p><img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/3cc70924b3ab74185ad71fe90d402dc31b6ead35e23c071e629cb519d6998e5e3d1907418e962c9192d0b994cd463a1439568da53918e40c0038a012aa8420707317e593995d92f07547d822aa4772e5bf3d952cde8dfda477bc763adda0015308fc8b18729c0da63f913a6a6b2c81ace3475faea09cc214e76b/file-1723698395598.png" alt="Interlink-Logo" style="object-fit: contain; height: 90px;padding: 30px 0;" /></div></section>
            <!-- Candidate Information -->
            <section style="max-width: 1024px; margin: auto"><div style="margin-bottom: 1000px;padding: 12px 32px;border-radius: 10px; background-color: #F3F4F6; line-height: 18px;"><p style="font-size: 26px;font-weight: 700; text-transform: uppercase;">Candidate Information</p><div style="display: grid;grid-template-columns: repeat(2, minmax(0, 1fr)); "><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Full Name</p><p style="font-size: 18px; font-weight: 500; ">${capitalizeEachWord(
              values.full_name
            )}</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Date of Evaluation</p><p style="font-size: 18px; font-weight: 500; ">${moment().format(
    "dddd, DD MMMM YYYY HH:mm A"
  )}</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Email Address</p><p style="font-size: 18px; font-weight: 500; ">${
    values.email_address
  }</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Phone Number</p><p style="font-size: 18px; font-weight: 500; ">${
    values.phone_code.value
  }-${
    values.phone_number
  }</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Company / Organization</p><p style="font-size: 18px; font-weight: 500; ">${
    values.company_name && values.company_name !== ""
      ? capitalizeFirstLetter(values.company_name)
      : "-"
  }</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Job Title / Position</p><p style="font-size: 18px; font-weight: 500; ">${
    values.job_title && values.job_title !== ""
      ? capitalizeFirstLetter(values.job_title)
      : "-"
  }</p></div></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Title Program</p><p style="font-size: 30px; line-height: 30px; font-weight: 600; color: #0EA5E9;">${
    values.selected_program
  }</p></div><div><p style="font-size: 18px;  font-weight: 700; color: #7D7D7D; text-transform: uppercase;">Signature</p><img style="margin-bottom: 20px;width: 100%;height: 300px;background-color: white;aspect-ratio: 16/9;object-fit: contain;border-radius: 10px;" src="${
    values.signature
  }"/></div></div></section>
            ${assessmentQuestionnaireTable}
            <!-- Interlink Logo -->
            <section style="max-width: 1024px; margin: auto"><div style="display: flex;justify-content: space-between;align-items: center;"><p style="font-size: 35px;font-weight: 700; text-transform: uppercase;">Evaluation Result</p><img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/3cc70924b3ab74185ad71fe90d402dc31b6ead35e23c071e629cb519d6998e5e3d1907418e962c9192d0b994cd463a1439568da53918e40c0038a012aa8420707317e593995d92f07547d822aa4772e5bf3d952cde8dfda477bc763adda0015308fc8b18729c0da63f913a6a6b2c81ace3475faea09cc214e76b/file-1723698395598.png" alt="Interlink-Logo" style="object-fit: contain; height: 90px;padding: 30px 0;" /></div></section>
            <!-- Assessment Result -->
            <section style="max-width: 1024px; margin: auto"><div style="margin-bottom: 30px;padding: 12px 32px 36px 32px;border-radius: 10px; background-color: #F3F4F6; line-height: 18px;text-align: center;"><p style="font-size: 40px; font-weight: 700; text-transform: uppercase; ">Submission Completed</p><p style="font-size: 25px;  font-weight: 700; ">Here is candidate's evaluation score:</p><p style="font-size: 100px;  font-weight: 700; ">${totalScore}</p><div style="padding: 12px 32px;border-radius: 10px; background-color: #7DD3FC; line-height: 28px;"><p style="font-size: 18px; text-align: justify; "><b>Initial Recommendations:</b><br />${finalInitialRecommendation}</p></div></div></section>
        </div>
    </body>
    `;
};
